const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || 'https://baranemlakgayrimenkul.com/api').replace(/\/$/, '')

export const assetUrl = (path) => path && (path.startsWith('http') ? path : `https://baranemlakgayrimenkul.com${path}`)
export const getToken = () => localStorage.getItem('token')
export const getUser = () => JSON.parse(localStorage.getItem('user') || 'null')
export const getGuestMessageId = () => {
  let id = localStorage.getItem('guest_message_id')
  if (!id) {
    id = globalThis.crypto?.randomUUID?.() || `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem('guest_message_id', id)
  }
  return id
}
export const setSession = ({ access_token, user }) => { localStorage.setItem('token', access_token); localStorage.setItem('user', JSON.stringify(user)) }
export const clearSession = () => { localStorage.removeItem('token'); localStorage.removeItem('user') }

export async function api(path, options = {}) {
  const { body, headers, ...rest } = options
  const token = getToken()
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...rest,
    headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}), ...(token ? { Authorization: `Bearer ${token}` } : {}), ...headers },
    body: body ? JSON.stringify(body) : undefined,
  })
  const data = await response.json().catch(() => null)
  if (!response.ok) throw new Error(data?.detail || data?.error || 'İşlem şu anda tamamlanamadı.')
  return data
}

// FormData gönderirken Content-Type başlığını tarayıcı belirler; aksi halde dosya
// yüklemelerinin gerekli multipart sınırı kaybolur.
export async function apiForm(path, formData, method = 'POST') {
  const token = getToken()
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: { Accept: 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: formData,
  })
  const data = await response.json().catch(() => null)
  if (!response.ok) throw new Error(data?.detail || data?.error || 'İşlem şu anda tamamlanamadı.')
  return data
}

export const getListings = (query = '') => api(`/ilanlar${query ? `?${query}` : ''}`)
export const getListing = (id) => api(`/ilanlar/${encodeURIComponent(id)}`)
export const getAdvisers = () => api('/danismanlar')
export const getAdviser = (username) => api(`/danismanlar/${encodeURIComponent(username)}`)
export const login = (credentials) => api('/auth/login', { method: 'POST', body: credentials })
export const register = (details) => api('/auth/register', { method: 'POST', body: details })
const guestMessageHeaders = () => ({ 'X-Web-Guest-ID': getGuestMessageId() })
export const createWebConversation = (listingId) => api('/web/conversations', { method: 'POST', body: { listingId }, headers: guestMessageHeaders() })
export const getWebMessages = (conversationId) => api(`/web/conversations/${encodeURIComponent(conversationId)}/messages`, { headers: guestMessageHeaders() })
export const sendWebMessage = (conversationId, messageText) => api(`/web/conversations/${encodeURIComponent(conversationId)}/messages`, { method: 'POST', body: { messageText }, headers: guestMessageHeaders() })
export const getCurrentUser = () => api('/auth/me')
export const getUserProfile = () => api('/users/me')
export const updateUserProfile = (profile) => api('/users/me', { method: 'PUT', body: profile })
export const getWebConversations = () => api('/web/conversations')
export const getMyListings = () => api('/ilanlar/my-ilanlar')
export const deleteListing = (listingId) => api(`/ilanlar/${encodeURIComponent(listingId)}`, { method: 'DELETE' })
export const getFavorite = (listingId) => api(`/ilanlar/${encodeURIComponent(listingId)}/favori`)
export const toggleFavorite = (listingId) => api(`/ilanlar/${encodeURIComponent(listingId)}/favori`, { method: 'POST', body: {} })
export const createListing = (listing, photos = []) => {
  if (!photos.length) return api('/ilanlar', { method: 'POST', body: listing })
  const form = new FormData()
  form.append('ilan_data', JSON.stringify(listing))
  photos.forEach((photo) => form.append('fotograflar[]', photo))
  return apiForm('/ilanlar', form)
}
export const updateListing = (listingId, listing, photos = []) => {
  if (!photos.length) return api(`/ilanlar/${encodeURIComponent(listingId)}`, { method: 'PUT', body: listing })
  const form = new FormData()
  form.append('ilan_data', JSON.stringify(listing))
  photos.forEach((photo) => form.append('fotograflar[]', photo))
  return apiForm(`/ilanlar/${encodeURIComponent(listingId)}`, form, 'PUT')
}
export const uploadListingPhotos = (listingId, photos) => {
  const form = new FormData()
  photos.forEach((photo) => form.append('fotograflar[]', photo))
  return apiForm(`/ilanlar/${encodeURIComponent(listingId)}/fotograflar`, form)
}
export const deleteListingPhoto = (listingId, photoId) => api(`/ilanlar/${encodeURIComponent(listingId)}/fotograflar/${encodeURIComponent(photoId)}`, { method: 'DELETE' })
export const setListingCover = (listingId, photoId) => api(`/ilanlar/${encodeURIComponent(listingId)}/vitrin/${encodeURIComponent(photoId)}`, { method: 'PUT', body: {} })
export const getPendingListings = () => api('/admin/ilanlar/bekleyen')
export const approveListing = (listingId) => api(`/admin/ilanlar/${encodeURIComponent(listingId)}/onayla`, { method: 'POST', body: { ilan_no: listingId } })
export const rejectListing = (listingId, reason) => api(`/admin/ilanlar/${encodeURIComponent(listingId)}/reddet`, { method: 'POST', body: { red_nedeni: reason } })
export const bulkListingAction = (listingIds, action) => api('/admin/listings/bulk-action', { method: 'POST', body: { listing_ids: listingIds, action } })
export const getAdminUsers = () => api('/admin/kullanicilar')
export const getPendingUsers = () => api('/admin/kullanicilar/bekleyen')
export const approveUser = (userId, roleId = 3) => api(`/admin/kullanicilar/${encodeURIComponent(userId)}/onayla`, { method: 'POST', body: { rol_id: roleId } })
export const rejectUser = (userId) => api(`/admin/kullanicilar/${encodeURIComponent(userId)}/reddet`, { method: 'POST', body: {} })
export const changeUserRole = (userId, roleId) => api(`/admin/kullanicilar/${encodeURIComponent(userId)}/rol`, { method: 'PUT', body: { rol_id: roleId } })
export const getReports = () => api('/admin/sikayetler')
export const reviewReport = (reportId) => api(`/admin/sikayetler/${encodeURIComponent(reportId)}/review`, { method: 'POST', body: { status: 'incelendi' } })
export const unpublishReportedListing = (reportId) => api(`/admin/sikayetler/${encodeURIComponent(reportId)}/unpublish`, { method: 'POST', body: {} })
export const getBlocks = () => api('/admin/blocks')
export const blockUser = (targetUserId, reason) => api('/admin/users/block', { method: 'POST', body: { targetUserId, reason } })
export const unblockUser = (targetUserId, targetDeviceId) => api('/admin/users/unblock', { method: 'POST', body: { ...(targetUserId ? { targetUserId } : {}), ...(targetDeviceId ? { targetDeviceId } : {}) } })
